module.exports = __webpack_public_path__ + "media/images/writer-offering-banner-title-39a94621e6a58180fe848be5d1818e59.png";